<!-- src/components/new-tip-v2/FiltersBar.vue -->
<!--
  Barre de filtres du dashboard v2.

  Reprend celle de la v1 en ajoutant le filtre « palier atteint », qui est le
  découpage le plus parlant en v2 : il permet d'isoler les visites sans aucun
  palier franchi (valeur 'none').
-->
<template>
  <v-card flat outlined class="mb-4">
    <v-card-text class="py-3">
      <v-row dense align="center">
        <v-col cols="12" sm="6" md="2">
          <v-autocomplete
            v-model="local.campaign_id"
            :items="campaigns"
            item-text="name"
            item-value="id"
            label="Campagne"
            dense hide-details clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-autocomplete
            v-model="local.supervisor_id"
            :items="supervisors"
            item-text="name"
            item-value="id"
            label="ASM"
            dense hide-details clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <!-- Recherche partielle : le code est saisi à la main, souvent de
               mémoire. Entrée applique, pour ne pas obliger à viser le bouton. -->
          <v-text-field
            v-model="local.salepoint_code"
            label="Code POS"
            placeholder="ex. 12101"
            prepend-inner-icon="mdi-store-search-outline"
            dense hide-details clearable
            @keyup.enter="apply"
            @click:clear="local.salepoint_code = null"
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-select
            v-model="local.status"
            :items="visitStatuses"
            label="Statut"
            dense hide-details clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-select
            v-model="local.achieved_tier"
            :items="tierOptions"
            label="Palier atteint"
            dense hide-details clearable
          />
        </v-col>
        <v-col cols="6" sm="3" md="auto">
          <v-menu v-model="dateFromMenu" :close-on-content-click="false" max-width="290">
            <template #activator="{ on }">
              <v-text-field
                :value="local.date_from" label="Du" readonly dense hide-details clearable
                v-on="on" @click:clear="local.date_from = null"
              />
            </template>
            <v-date-picker v-model="local.date_from" no-title @input="dateFromMenu = false" />
          </v-menu>
        </v-col>
        <v-col cols="6" sm="3" md="auto">
          <v-menu v-model="dateToMenu" :close-on-content-click="false" max-width="290">
            <template #activator="{ on }">
              <v-text-field
                :value="local.date_to" label="Au" readonly dense hide-details clearable
                v-on="on" @click:clear="local.date_to = null"
              />
            </template>
            <v-date-picker v-model="local.date_to" no-title @input="dateToMenu = false" />
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mt-1" no-gutters>
        <v-spacer />
        <v-btn small text @click="reset">Réinitialiser</v-btn>
        <v-btn small color="primary" class="ml-2" @click="apply">
          <v-icon left small>mdi-filter</v-icon>
          Appliquer
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { VISIT_STATUSES, ACHIEVED_TIER_OPTIONS } from '@/constants/newTipV2';

export default {
  name: 'NewTipV2FiltersBar',
  props: {
    value: { type: Object, default: () => ({}) },
    campaigns: { type: Array, default: () => [] },
    supervisors: { type: Array, default: () => [] },
  },
  data() {
    return {
      local: { ...this.emptyFilters(), ...this.value },
      dateFromMenu: false,
      dateToMenu: false,
      visitStatuses: VISIT_STATUSES.map(s => ({ value: s.value, text: s.label })),
      tierOptions: ACHIEVED_TIER_OPTIONS.map(o => ({ value: o.value, text: o.label })),
    };
  },
  watch: {
    value: { deep: true, handler(v) { this.local = { ...this.emptyFilters(), ...v }; } },
  },
  methods: {
    emptyFilters() {
      return {
        campaign_id: null,
        supervisor_id: null,
        salepoint_id: null,
        salepoint_code: null,
        status: null,
        achieved_tier: null,
        date_from: null,
        date_to: null,
      };
    },
    apply() {
      this.$emit('input', { ...this.local });
      this.$emit('apply', { ...this.local });
    },
    reset() {
      this.local = this.emptyFilters();
      this.apply();
    },
  },
};
</script>
